import type { ChangeEvent } from 'react';
import { useTranslation } from 'next-i18next';
import { getLanguageLiteralFromLocale } from '../../../utils';
import { LanguageSelectionContainer, LanguageSelectionList, LanguageSelectionWrapper } from './LanguageSelection.style';

export function LanguageSelection({
  defaultLanguage = '',
  languages,
  onChange,
  languageSelectionError,
  uniqueKey,
}: {
  defaultLanguage?: string;
  languages: string[];
  onChange: ({ target: { name, checked } }: ChangeEvent<HTMLInputElement>) => void;
  languageSelectionError?: boolean;
  uniqueKey: string;
}) {
  const { t } = useTranslation('lib-global-common');

  return (
    <LanguageSelectionContainer>
      <p>{t('footer.newsletter.language.selection')}</p>
      <LanguageSelectionList label={t('footer.newsletter.radio.language.selection')}>
        {languages.map((language) => {
          const lang = getLanguageLiteralFromLocale(language);

          return (
            <LanguageSelectionWrapper key={`newsletter-language-${lang}`}>
              <input
                type="radio"
                aria-describedby={languageSelectionError ? `${uniqueKey}-language-error` : undefined}
                id={`${uniqueKey}-language-${lang}`}
                value={lang}
                name="language"
                onChange={onChange}
                defaultChecked={defaultLanguage.toLowerCase() === lang.toLowerCase()}
                data-testid={`${uniqueKey}LanguageSelection`}
              />
              <label htmlFor={`${uniqueKey}-language-${lang}`}>{t(`footer.newsletter.language.${lang}`)}</label>
            </LanguageSelectionWrapper>
          );
        })}
      </LanguageSelectionList>
    </LanguageSelectionContainer>
  );
}
